import { toast } from 'react-toastify';
import { toNumberOrZero } from '~/utils/functions';
import { validaTipoItemNcmDepartamento } from '~/utils/validaTipoItemNcmDepartamento';
import { RowTableNCMEmLote } from '../types/context';

type LojaInfo = { cod_loja: number; des_uf: string };

export const validateNcmForSelection = async ({
  selectedRows,
  lojasInfo,
  novoNcm,
  lojas,
}: {
  selectedRows: RowTableNCMEmLote[];
  lojasInfo: LojaInfo[];
  novoNcm: string | number;
  lojas: any;
}): Promise<boolean> => {
  const lojaInfoByCodLoja = new Map<number, LojaInfo>(
    lojasInfo.map((info) => [info.cod_loja, info]),
  );

  const pairsBuild = selectedRows.reduce(
    (acc, row) => {
      if (!acc.ok) return acc;

      const codLoja = toNumberOrZero(row.cod_loja);
      const tipoItem = toNumberOrZero(row.cod_tipo_item);

      const lojaInfo = lojaInfoByCodLoja.get(codLoja);

      if (!lojaInfo) {
        acc.ok = false;
        acc.error = `Não foi possível identificar a UF da loja ${codLoja}.`;
        return acc;
      }

      const key = `${codLoja}|${tipoItem}`;

      if (!acc.map.has(key)) {
        acc.map.set(key, {
          cod_loja: lojaInfo.cod_loja,
          des_uf: lojaInfo.des_uf,
          cod_tipo_item: tipoItem,
          label: row.des_tipo_item ?? '',
        });
      }

      return acc;
    },
    {
      ok: true as boolean,
      error: '' as string,
      map: new Map<
        string,
        {
          cod_loja: number;
          des_uf: string;
          cod_tipo_item: number;
          label: string;
        }
      >(),
    },
  );

  if (!pairsBuild.ok) {
    toast.warn(pairsBuild.error || 'Não foi possível validar as lojas.');
    return false;
  }

  const pairs = Array.from(pairsBuild.map.values());

  const canProceed = await pairs.reduce<Promise<boolean>>((promise, pair) => {
    return promise.then(async (prevCanProceed) => {
      if (!prevCanProceed) return false;

      const shouldBlock = await validaTipoItemNcmDepartamento(
        {
          cod_ncm: { value: novoNcm },
          cod_tipo_item: {
            value: pair.cod_tipo_item,
            label: pair.label,
          },
        },
        { cod_loja: pair.cod_loja, des_uf: pair.des_uf },
        lojas,
      );

      return !shouldBlock;
    });
  }, Promise.resolve(true));

  return canProceed;
};
